import axios from 'axios';
import * as dotenv from 'dotenv';

dotenv.config();

const config = {
    headers: {
        'key-brandsurvey-api-key': process.env.KEY_BRANDSURVEY_API
    }
}

const optionDivs = document.querySelector('#options');
const questionDiv = document.querySelector('#survey-question');

const params = new URLSearchParams(document.location.search);
const campaignID = params.get("campaign");
const audienceID = params.get("audienceID");

const cookieCampaingIDMatch = document.cookie.match(RegExp('(?:^|;\\s*)' + 'campaign' + '=([^;]*)'));

const campaignCookieArray = cookieCampaingIDMatch && JSON.parse(cookieCampaingIDMatch[1]);

document.getElementById("thankyou-container").classList.add("hide");
document.getElementById("question-container").classList.add("hide");
document.getElementById("fallback-container").classList.add("hide");

if (campaignCookieArray && campaignCookieArray.includes(Number(campaignID))) {
    document.getElementById("fallback-container").classList.remove("hide");
} else {
    axios.post(process.env.KEY_BRANDSURVEY_URL, {
        campaignID,
        audienceID,
    }, config).then((response) => {

        questionDiv.textContent = response.data.options[0].SurveyQuestion;
        const isSingleSelect = !response.data.options[0].IsSurveyQuestionMultiselect;
    
        const options = response.data.options;

        const shuffledOptions = options.map(value => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);
        
        shuffledOptions.forEach(option => {
            const submitButton = document.getElementById("submit-button");

            const optionContainer = document.createElement('div');
            optionContainer.classList.add('option');

            const optionCheckbox = document.createElement('input');
            optionCheckbox.classList.add('option-checkbox');
            optionCheckbox.type = "checkbox";
            optionCheckbox.id = option.SurveyResponseID;
            optionCheckbox.value = option.SurveyResponseID;
            optionCheckbox.name = option.SurveyResponseID;
            optionCheckbox.onchange = function() {
                const checkboxElements = document.getElementsByClassName('option-checkbox')
                
                if (isSingleSelect) {
                    for (let idx = 0; idx < checkboxElements.length; idx++) {
                        const checkbox = checkboxElements.item(idx);
                        checkbox.checked = false;
                    }

                    this.checked = true;
                }
                
                const checkboxes = Array.prototype.slice.call(checkboxElements);
                const isAnyCheckboxChecked = checkboxes.some(checkbox => checkbox.checked);
                submitButton.disabled = !isAnyCheckboxChecked;
            }
            
            const optionLabel = document.createElement('label');
            optionLabel.classList.add('option-label');
            optionLabel.htmlFor = option.SurveyResponseID;
            optionLabel.innerHTML = option.SurveyResponseName;
            
            optionContainer.appendChild(optionLabel);
            optionContainer.appendChild(optionCheckbox);

            optionDivs.append(optionContainer);
            
            submitButton.onclick = function() {
                document.getElementById("question-container").classList.add("hide");
                document.getElementById("thankyou-container").classList.remove("hide");
                let cookieArray = [];
                if (campaignCookieArray) {
                    campaignCookieArray.push(Number(response.data.campaignID));
                    cookieArray = campaignCookieArray;
                } else {
                    cookieArray.push(Number(response.data.campaignID));
                }
                const cookieArrayString = JSON.stringify(cookieArray);
                document.cookie = `campaign=${cookieArrayString}; SameSite=None; Secure`;
                
                const checkboxElements = document.getElementsByClassName('option-checkbox')
                const checkboxes = Array.prototype.slice.call(checkboxElements);
                const checkedBoxes = checkboxes.filter(checkbox => checkbox.checked).map(checkbox => checkbox.value);

                submitAnswer(checkedBoxes, response.data.campaignID, response.data.audienceID)
            };
        })
    
        document.getElementById("question-container").classList.remove("hide");
    
    }).catch((error) => {
        console.log('error in sending request ', error);
    });
}

const submitAnswer = function(surveyResponseIDs, campaignID, audienceID) {
    axios.post(process.env.KEY_BRANDSURVEY_URL, {
        campaignID,
        audienceID,
        surveyResponseIDs
    }, config);
};

